









import { SteppedAnimationMixin } from '../../mixins/stepped-animation.mixin';

import FunnelChart from './funnel-chart.component.vue';
import SteppedKpisBar from './stepped-kpis-bar.component.vue';

export default {
  name: 'kpis-success',
  mixins: [SteppedAnimationMixin],
  components: {
    FunnelChart,
    SteppedKpisBar
  },
  props: {
    selectedId: String
  },
  computed: {
    kpisSuccessItemProps: function () {
      return {
        selectedId: this.selectedId,
        animationStepDurationsInMillis: this.animationStepDurationsInMillis,
        currentAnimationStep: this.currentAnimationStep
      };
    }
  },
  data: function () {
    return {
      animationStepDurationsInMillis: [
        SteppedAnimationMixin.data().animationStepDurationsInMillis[0],
        SteppedAnimationMixin.data().animationStepDurationsInMillis[1] + SteppedAnimationMixin.data().animationStepDurationsInMillis[2]
      ]
    };
  }
};
